const getCharacter = ({ state, id }) => {
  const { characters } = state;
  return characters && characters.find(character => character.id === id);
};

const getAllCharacters = ({ state }) => {
  const { characters } = state;
  const position = (a, b) => ((a.position > b.position) ? 1 : -1);
  return characters && characters.sort(position);
};

export default {
  getCharacter: state => id => getCharacter({ state, id }),
  getAllCharacters: state => getAllCharacters({ state }),
};
